import { t } from "@/i18n-js/instance";
import type { SectionConfig } from "@/react/types/Checklist";
import { stepKeys } from "@/react/types/Checklist";

export const localeRoot = "community_onboarding.new_checklist.setup_checklist";

export const sections: readonly SectionConfig[] = [
  {
    key: "complete_profile",
    title: t(`${localeRoot}.sections.complete_profile.title`),
    steps: [stepKeys.account_created, stepKeys.personalize_profile],
  },
  {
    key: "design_community",
    title: t(`${localeRoot}.sections.design_community.title`),
    steps: [stepKeys.customize_branding, stepKeys.create_spaces],
  },
  {
    key: "setup_access",
    title: t(`${localeRoot}.sections.setup_access.title`),
    steps: [
      stepKeys.confirm_access,
      stepKeys.create_access_group,
      stepKeys.setup_payments,
    ],
  },
  {
    key: "launch_community",
    title: t(`${localeRoot}.sections.launch_community.title`),
    steps: [
      stepKeys.add_members,
      stepKeys.create_invite_link,
      stepKeys.import_email_list,
      stepKeys.send_launch_announcement,
    ],
  },
] as const;
